export default "__VITE_ASSET__DlRslmi4__"